import React, { useEffect, useRef, useState } from 'react'
import { PnlDailyContainer, PnlDailyText } from './DailyPnl.style'
import { webSocketWorkerEvent, webSocketWorkerPriceEvent } from '../../../../services'
import { useSelector } from 'react-redux'
import useAxios from '../../../../hooks/useAxios'
import { routes } from '../../../../utils/constants'

const DailyPnl = () => {
  const { response: currencyPairResponse, getRequestData } = useAxios({
    endPoint: routes.currencyPair
  })
  const [dealsPnl, setDealsPnlState] = useState(0)
  const [pnl, setPnl] = useState('...')
  const productsPrice = useRef({})
  const bloombergConnection = useRef(false)
  const [report, setReport] = useState(false)
  const token = useSelector(state => state.auth.token)

  const lastSentSnapshot = useRef(null)

  useEffect(() => {
    webSocketWorkerPriceEvent.connectPricerWS(token)
  }, [token])

  useEffect(() => {
    const handelMessage = async message => {
      if (
        message.data.type === 'get_daily_pnl' &&
        message.data.status === 'ok' &&
        typeof message.data.data === 'number'
      ) {
        const { data } = message.data
        setDealsPnlState(data)
        setPnl(Number(data).toFixed(2).toLocaleString())
      } else if (message.data.type === 'add_currency_pair_price') {
        setReport(true)
      } else if (message.data.type === 'refresh_rates') {
        await getRequestData()
        lastSentSnapshot.current = 'update'
        setReport(true)
      }
    }
    webSocketWorkerEvent.addEventListener('message', handelMessage)
    return () => webSocketWorkerEvent.removeEventListener('message', handelMessage)
  }, [])

  useEffect(() => {
    const handelMessage = message => {
      let symbol
      if (message.data.security === 'connection_status' && !message.data.status) {
        bloombergConnection.current = false
        return
      }
      if (message.data.security === 'connection_status' && message.data.status) {
        bloombergConnection.current = true
      }

      if (
        message.data &&
        message.data.action === 'new' &&
        message.data.base_currency &&
        message.data.counter_currency &&
        message.data.LAST_PRICE
      ) {
        const { base_currency, counter_currency } = message.data
        symbol = `${base_currency}${counter_currency}`

        if (!productsPrice.current[symbol]) {
          productsPrice.current[symbol] = {
            price: message.data.LAST_PRICE,
            LAST_PRICE: message.data.LAST_PRICE,
            action: message.data.action,
            base_currency: message.data.base_currency,
            base_currency_country: message.data.base_currency_country,
            counter_currency: message.data.counter_currency,
            counter_currency_country: message.data.counter_currency_country,
            order_id: message.data.order_id,
            security: message.data.security
          }
        } else {
          productsPrice.current[symbol].LAST_PRICE = message.data.LAST_PRICE
          productsPrice.current[symbol].action = message.data.action
          productsPrice.current[symbol].base_currency = message.data.base_currency
          productsPrice.current[symbol].base_currency_country = message.data.base_currency_country
          productsPrice.current[symbol].counter_currency = message.data.counter_currency
          productsPrice.current[symbol].counter_currency_country =
            message.data.counter_currency_country
          productsPrice.current[symbol].order_id = message.data.order_id
          productsPrice.current[symbol].security = message.data.security
        }
      }

      if (report === true) {
        let baseCurrency = {}
        let allDealIn = true,
          symbol
        if (Array.isArray(currencyPairResponse.data)) {
          for (const { base_currency, counter_currency } of currencyPairResponse.data) {
            symbol = `${base_currency}${counter_currency}`
            if (baseCurrency[symbol] !== 1) {
              baseCurrency[symbol] = 0
            }
            if (productsPrice.current[symbol]) {
              baseCurrency[symbol] = 1
            } else {
              allDealIn = false
            }
          }
        } else {
          return
        }
        if (allDealIn && lastSentSnapshot.current === null) {
          webSocketWorkerEvent.sendEvent({
            type: 'add_currency_pair_price',
            data: productsPrice.current
          })
          lastSentSnapshot.current = productsPrice.current
          setReport(false)
          webSocketWorkerPriceEvent.removeEventListener('message', handelMessage)
        } else if (allDealIn && lastSentSnapshot.current === 'update') {
          webSocketWorkerEvent.sendEvent({
            type: 'update_currency_pair_price',
            data: productsPrice.current
          })
          lastSentSnapshot.current = productsPrice.current
          setReport(false)
          webSocketWorkerPriceEvent.removeEventListener('message', handelMessage)
        }
      }
    }
    webSocketWorkerPriceEvent.addEventListener('message', handelMessage)
    return () => webSocketWorkerPriceEvent.removeEventListener('message', handelMessage)
  }, [report, dealsPnl, currencyPairResponse.data])

  return (
    <PnlDailyContainer>
      <PnlDailyText>Total P&L {pnl}</PnlDailyText>
    </PnlDailyContainer>
  )
}

export default DailyPnl
